export const TEST_IDS = {
  MENU: 'user-menu--menu',
  EMAIL: 'user-menu--email',
  CARD_EMAIL: 'user-menu-card--email',
  CARD_ROLE: 'user-menu-card--role',
};
